var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("metric-bar", { attrs: { metrics: _vm.metrics } }),
      _vm._v(" "),
      _c("report-base", {
        attrs: {
          title: "Property Summary",
          "table-class": "analytics-tables--summary",
          subject: "summary",
          stacked: true,
          search: false,
          items: _vm.summary,
          fields: _vm.fields,
          "is-loading": _vm.loading,
        },
        on: { reload: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }